export class Navigation {

    constructor() {
        this.navigation('[data-js=navigation]');
        this.fixLanguageNavigation();
    }

    /**
     * Handle visibility of responsive navigation
     * @param toggleButton {String} Button identifier
     * @method navigation
     */
    navigation(toggleButton) {

        /**
         * CTA identifier
         * @type {string}
         */
        var subMenuCTA = '[data-js=nav-sub]';

        /**
         * CTA identifier
         * @type {string}
         */
        var subMenuCTABack = '[data-js=nav-sub-back]';

        /**
         * observe toggle button
         * @method observer
         * @return {undefined}
         */
        $(toggleButton).click(function () {
            $('body').toggleClass('show-responsive-nav');
        });

        $(subMenuCTA).click(function () {
            var submenu = $(this).parent().find('> .main-nav--sub');
            submenu.addClass('visible');
        });

        $(subMenuCTABack).click(function () {
            $(this).closest('.main-nav--sub').removeClass('visible');
        });

    }

    /**
     * Fixes the rendering of the language menu
     * @method fixLanguageNavigation
     */
    fixLanguageNavigation() {
        var $languageMenu = $('.language-menu');
        // hide language menu if there are no valid links present
        if ($languageMenu.find('.language-menu_language-link').length === 0) {
            $languageMenu.hide();
        }
    }
}